// Endpoint TUS resumable de Supabase Storage.
// On vise le hostname `*.storage.supabase.co` (et non `*.supabase.co`) :
// la doc Supabase impose ce hostname direct pour de bonnes perfs sur gros
// fichiers (rencontres longues). Pour un domaine hors supabase.co (self-host
// ou domaine custom), on garde l'origine telle quelle.
export function buildResumableEndpoint(supabaseUrl: string): string {
  const url = new URL(supabaseUrl);
  if (url.hostname.endsWith(".supabase.co") && !url.hostname.includes(".storage.")) {
    url.hostname = url.hostname.replace(/\.supabase\.co$/, ".storage.supabase.co");
  }
  return `${url.origin}/storage/v1/upload/resumable`;
}
